import React from "react";
import { makeStyles } from "@material-ui/styles"
import {
	DialogContent,
	DialogActions,
	Button
 } from '@material-ui/core';
import { no_op } from 'utilities';
import { DialogWithFocusProvider, CloseableDialogTitle } from "components/layout";

const useStyles = makeStyles({
	noPadding: {
		padding: 0
	}
})

export default function ModalPage({
	children,
	maxWidth = "md",
	height = null,
	title = null,
	open = true,
	onClose = no_op,
	additionalActions = [],
	disablePadding = false,
	disableBackdrop = true,
	disableEsc = false,
	fullScreen = false,
	...rest
}) {
	const classes = useStyles();
	const style = { height };
	const className = disablePadding ? classes.noPadding : "";

	const handleClose = (e, reason) => {
		if (disableBackdrop && reason === 'backdropClick') return; // updated handling for disableBackdropClick
		onClose();
	}

	return (
		<DialogWithFocusProvider
			fullWidth
			maxWidth={maxWidth}
			fullScreen={fullScreen}
			open={open} 
			onClose={handleClose} 
			disableEscapeKeyDown={disableEsc}
			{...rest}
		>
			<CloseableDialogTitle onClose={handleClose}>{title}</CloseableDialogTitle>
			<DialogContent style={style} className={className}>
				{children}
			</DialogContent>
			<DialogActions>
				{additionalActions.map((aa) => (
					<Button onClick={aa.onClick} color={aa.color || "primary"} key={aa.key}>{aa.text}</Button>
				))}                
			</DialogActions>
		</DialogWithFocusProvider>
	)
}